"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _Checkbox = require("../form/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserProfileForm = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(UserProfileForm, _Component);

  function UserProfileForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, UserProfileForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UserProfileForm.__proto__ || (0, _getPrototypeOf2.default)(UserProfileForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (values) {

      // quick fix for error when submiting form without address (ilmaiskayttaja)
      if (values.address == null) {
        values.address = "";
      }

      values.send_transfer_requests = values.send_transfer_requests || false;
      _this.props.userUpdate(_this.props.auth.user.id, values);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(UserProfileForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var user = this.props.auth.user;
      var _props$fields = this.props.fields,
          first_name = _props$fields.first_name,
          last_name = _props$fields.last_name,
          email = _props$fields.email,
          phone = _props$fields.phone,
          address = _props$fields.address,
          postal_code = _props$fields.postal_code,
          postal_area = _props$fields.postal_area,
          send_transfer_requests = _props$fields.send_transfer_requests,
          order_reference = _props$fields.order_reference;

      first_name.onChange(user.first_name);
      last_name.onChange(user.last_name);
      email.onChange(user.email);
      phone.onChange(user.phone);
      address.onChange(user.address.street_address);
      postal_code.onChange(user.address.postal_code);
      postal_area.onChange(user.address.postal_area);
      send_transfer_requests.onChange(user.send_transfer_requests);
      order_reference.onChange(user.order_reference);
    }
  }, {
    key: "render",
    value: function render() {

      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h1",
            { className: "h4" },
            "Profiilin asetukset"
          ),
          _react2.default.createElement(
            "p",
            null,
            "T\xE4ll\xE4 sivulla voit muokata omia tietojasi ja vaihtaa uuden salasanan."
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h2",
            { className: "h4 form-title" },
            "OMAT TIETONI"
          )
        ),
        this.renderLicenseInfo(),
        this.renderProfileForm()
      );
    }
  }, {
    key: "renderProfileForm",
    value: function renderProfileForm() {
      var _props$fields2 = this.props.fields,
          first_name = _props$fields2.first_name,
          last_name = _props$fields2.last_name,
          email = _props$fields2.email,
          phone = _props$fields2.phone,
          password = _props$fields2.password,
          password2 = _props$fields2.password2,
          send_transfer_requests = _props$fields2.send_transfer_requests,
          address = _props$fields2.address,
          postal_code = _props$fields2.postal_code,
          postal_area = _props$fields2.postal_area,
          order_reference = _props$fields2.order_reference;
      var auth = this.props.auth;


      return _react2.default.createElement(
        "form",
        { id: "userUpdateForm", className: "col col-xs-12", onSubmit: this.props.handleSubmit(this.onSubmit) },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "first_name", type: "text", label: "Etunimi", fieldProps: first_name })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "last_name", type: "text", label: "Sukunimi", fieldProps: last_name })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "email", type: "email", label: "S\xE4hk\xF6posti", fieldProps: email })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "phone", type: "text", label: "Puhelinnumero", fieldProps: phone })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              _Input2.default,
              { id: "password", type: "password", label: "Salasana", fieldProps: password },
              _react2.default.createElement(
                "p",
                { className: "small" },
                "Salasanan tulee olla v\xE4hint\xE4\xE4n 8 merkki\xE4 pitk\xE4."
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "password2", type: "password", label: "Salasana uudelleen", fieldProps: password2 })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(_Input2.default, { id: "address", type: "text", label: "Katuosoite", fieldProps: address })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6" },
            _react2.default.createElement(_Input2.default, { id: "postal_code", type: "text", label: "Postinumero", fieldProps: postal_code })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6" },
            _react2.default.createElement(_Input2.default, { id: "postal_area", type: "text", label: "Paikkakunta", fieldProps: postal_area })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6" },
            _react2.default.createElement(_Input2.default, { id: "order_reference", type: "text", label: "Tilausviite", fieldProps: order_reference })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Checkbox2.default, { id: "send_transfer_requests", label: "Kuljetustarjouspyynn\xF6t sa\u0308hko\u0308postiini", fieldProps: send_transfer_requests }),
            _react2.default.createElement(
              "p",
              null,
              "Ilmoituksen j\xE4tt\xE4misen yhteydess\xE4 k\xE4ytt\xE4jill\xE4 on mahdollisuus pyyt\xE4\xE4 ilmoitustaan koskevia kuljetustarjouksia muilta Maap\xF6rssin k\xE4ytt\xE4jilt\xE4. Tarjouspyynn\xF6t tulevat kaikkien niiden k\xE4ytt\xE4jien s\xE4hk\xF6posteihin, jotka ovat profiilinsa asteuksista valinneet vastaanottavansa kuljetustarjouspyynn\xF6t s\xE4hk\xF6postiinsa."
            )
          ),
          this.renderErrorMessage(),
          this.renderSuccessMessage()
        ),
        _react2.default.createElement(_SubmitButton2.default, { text: "Tallenna", submitting: auth.userUpdateLoading || false })
      );
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      var userUpdateError = this.props.auth.userUpdateError;

      if (userUpdateError) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "error-message error-message-js" },
            "Tietojen muuttaminen ep\xE4onnistui. Tarkista antamasi tiedot tai yrit\xE4 my\xF6hemmin uudelleen!"
          )
        );
      }
    }
  }, {
    key: "renderLicenseInfo",
    value: function renderLicenseInfo() {
      var user = this.props.auth.user;


      var todaysDate = (0, _moment2.default)(new Date());
      var paidUntil = (0, _moment2.default)(user.paid_until);
      var diffDays = paidUntil.diff(todaysDate, "days");

      if (user) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            null,
            "Tilauksesi on voimassa: ",
            (0, _moment2.default)(user.paid_until).format("D.M.YYYY"),
            " asti."
          )
        );
      }
    }
  }, {
    key: "renderSuccessMessage",
    value: function renderSuccessMessage() {
      var userUpdateSuccess = this.props.auth.userUpdateSuccess;

      if (userUpdateSuccess) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "success-message success-text-js" },
            "Tietojen muokkaus onnistui!"
          )
        );
      }
    }
  }]);
  return UserProfileForm;
}(_react.Component), _class.propTypes = {
  handleSubmit: _react.PropTypes.func.isRequired,
  fields: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object.isRequired,
  userUpdate: _react.PropTypes.func.isRequired
}, _temp2);
exports.default = UserProfileForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/myprofile/UserProfileForm.js
 ** module id = 1167
 ** module chunks = 0
 **/